import axiosInstance from "../../../axios";
import config from "../../../config";

export const createContactSlice = (set, get) => ({
    contact: {
        loading: false,
        data: [],
        ContactUsType: [],
        ContactUsMessage: null,
    },
    getContact: async () => {
        const token = get().business.currentBusiness.token;
        set(state => ({ contact: { ...state.contact, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `v1/public/contact-us`,
                headers: { token }
            });
            set(state => ({ contact: { ...state.contact, loading: false, ContactUsType: resp.data } }));
        } catch (error) {
            set(state => ({ contact: { ...state.contact, loading: false } }));
        }
    },
    postContactUsMessage: async (param) => {
        const token = get().business.currentBusiness.token;
        set(state => ({ contact: { ...state.contact, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'post',
                baseURL: config.apiUrls(),
                url: '/v1/business/contact-us-update',
                data: param,
                headers: { token }
            });
            set(state => ({ contact: { ...state.contact, loading: false, ContactUsMessage: resp.data } }));
            // Additional actions like getting tickets and notifying success would go here
        } catch (error) {
            set(state => ({ contact: { ...state.contact, loading: false } }));
        }
    }
});
